import React, { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
  EmailIcon,
} from 'react-share'
import widget from '../../../assets/img/widget.gif'

import './../Tabs/Editor/Editor.scss'
import { Plann3rStore } from '../../../store/types'
import { PagesManagementStore } from '../../../store/pages-management/types'
import { Company } from '../../../types/plann3r'
import { APP_URL } from '../../../constants'

const Share: FC = () => {
  const [copied /*, setcopied*/] = useState(false)

  const { companies, active_company, active_page } = useSelector(
    (state: Plann3rStore): PagesManagementStore => state.pagesManagement,
  )

  const company = companies.find(
    (company: Company) => company.id === active_company,
  )

  const page = company?.pages.find((page) => page.id === active_page)

  const link = (APP_URL + '/page/' + company?.name + '/' + page?.name).replace(
    / /g,
    '_',
  )

  const iFrameCode = '<iframe src="' + link + '" height=800 width=400></iframe>'
  const buttonCode =
    '<a href= "#" onclick="window.open(\'' +
    link +
    '\',\'popUpWindow\',\'height=800,width=600,left=10,top=10,,scrollbars=yes,menubar=no\'); return false;">\n' +
    '  Just click here to request a meeting' +
    '</a>'

  const popupButtonClicked = () => {
    window.open(
      link,
      'popUpWindow',
      'height=800,width=600,left=10,top=10,,scrollbars=yes,menubar=no',
    )
  }

  const renderEmbedCode = () => {
    return (
      <div className="part">
        <h3 className="part_header">Add your Plann3r page to your website!</h3>
        <h4>Add an iFrame</h4>
        <div>
          Using an iFrame, people can see the entire meeting page without having
          to click on anything or leaving your website.
          <br />
          This is perfect for contact-pages or landing-pages!
          <div className="codeExample">
            <pre>
              <code>{iFrameCode}</code>
            </pre>
          </div>
          <CopyToClipboard text={iFrameCode}>
            <button
              className={`button is-primary ${copied ? '' : 'is-outlined'}`}
            >
              {copied ? 'Copied' : 'Copy to clipboard'}
            </button>
          </CopyToClipboard>
        </div>
        <br />

        <h4>Add a button or a link</h4>
        <div>
          When someone clicks your button or link, your Plann3r page will open
          in a pop-up. <br />
          This is perfect to add to your landingpages, blogposts and all other
          existing content.
          <br />
          <button className="jsbutton" onClick={popupButtonClicked}>
            Your button could look like this!
          </button>
          <div className="codeExample">
            <pre>
              <code>{buttonCode}</code>
            </pre>
          </div>
          <CopyToClipboard text={buttonCode}>
            <button
              className={`button is-primary ${copied ? '' : 'is-outlined'}`}
            >
              {copied ? 'Copied' : 'Copy to clipboard'}
            </button>
          </CopyToClipboard>
        </div>
      </div>
    )
  }

  const renderSocials = () => {
    const emailBody = 'Schedule a meeting with me using this link  ' + link
    return (
      <div className="part">
        <h3 className="part_header">Share on social media</h3>
        <div>
          <LinkedinShareButton
            url={link}
            windowWidth={750}
            windowHeight={600}
            className="shareButton"
          >
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
          <FacebookShareButton url={link} className="shareButton">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <WhatsappShareButton url={link} className="shareButton">
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
          <EmailShareButton
            url={link}
            subject="Meeting"
            body={emailBody}
            className="shareButton"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
      </div>
    )
  }

  const renderWidget = () => {
    const shortnerLink =
      'http://s.plann3r.com/?company=' + company?.name + '&page=' + page?.name
    return (
      <div className="part">
        <h3 className="part_header">
          Share any link online and include the Plann3r widget!
        </h3>
        <div>
          <img className="widgetImage" alt="" src={widget} />
          <br />
          <a href={shortnerLink} className="widgetButton">
            Create a free Plann3r widget{' '}
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className="sharepage">
      {renderSocials()}
      <hr />
      {renderWidget()}
      <hr />
      {renderEmbedCode()}
    </div>
  )
}

export default Share
